module.exports = __webpack_public_path__ + "img/NU.b485bd35.svg";